import { Keyboard } from '@capacitor/keyboard';
import { DebouncedFunc, debounce } from 'lodash';
import { KeyboardExtension } from '../plugins/keyboard.plugin';

class KeyboardServiceImpl {
  private setAccesoryBarVisibleDebounced: DebouncedFunc<
    (visible: boolean) => void
  >;

  constructor() {
    this.setAccessoryBarVisible = this.setAccessoryBarVisible.bind(this);

    this.setAccesoryBarVisibleDebounced = debounce(
      this.setAccessoryBarVisible,
      10,
      {
        trailing: true,
      }
    );
  }

  public async hideAccessoryBar(): Promise<void> {
    this.setAccesoryBarVisibleDebounced(false);
  }

  public async showAccessoryBar(): Promise<void> {
    const isPhysicalKeyboard = await this.isPhysicalKeyboard();

    if (!isPhysicalKeyboard) {
      this.setAccesoryBarVisibleDebounced(true);
    }
  }

  public async isPhysicalKeyboard(): Promise<boolean> {
    try {
      const { isPhysicalKeyboard } =
        await KeyboardExtension.isPhysicalKeyboard();

      return isPhysicalKeyboard;
    } catch (error) {
      // do nothing since extension is not available
    }

    return false;
  }

  private async setAccessoryBarVisible(visible: boolean): Promise<void> {
    try {
      await Keyboard.setAccessoryBarVisible({ isVisible: visible });
    } catch (error) {
      // do nothing if Keyboard is not available
    }
  }
}

export const KeyboardService = new KeyboardServiceImpl();
